import React, {FunctionComponent, useState} from "react";
import {Button} from "./Button";
import {GenericModal} from "./Modal";
import styled from "styled-components";
import PasswordField from "./PasswordField";

interface VerifyWithPasswordModalProps {
  isOpen: boolean;
  title: string;
  subtitle?: string;
  onRequestClose: () => void;
  onConfirm: (password: string) => void;
}


export const VerifyWithPasswordModal
  : FunctionComponent<VerifyWithPasswordModalProps>
  = ({isOpen, title, subtitle, onRequestClose, onConfirm}) => {

  const [password, setPassword] = useState("");

  return <GenericModal isOpen={isOpen} onRequestClose={onRequestClose} modalStyle={modalStyles}>
    <Container>
      <p className={'title'}>{title}</p>
      {subtitle && <p>{subtitle}</p>}
      <FormContainer>
        <PasswordField
          id={'verify-password'}
          value={password || ''}
          onChange={(e) => setPassword(e.target.value)}
          label={'Salasana'}
        />
      </FormContainer>
      <ButtonsContainer>
        <Button onClick={() => {
          if (password) {
            onConfirm(password);
          }
        }}>OK</Button>
        <Button className="invisible" onClick={onRequestClose}>
          Peruuta
        </Button>
      </ButtonsContainer>
    </Container>
  </GenericModal>;
}

const Container = styled.div`
	text-align: center;
	.title {
		font-size: 1.5em;
	}
`;

const FormContainer = styled.div`
	margin-bottom: 1.818em;
`;

const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    
    > * {
        width: auto;
    }
`


const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#bcbcbc',
    width: '100%',
    height: '100%',
    padding: '2.102em 0.909em 0em 1.023em'
  },
  content: {
    height: 'auto',
    minHeight: '0px',
    width: '35em'
  }
};
